<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M15.0588 10.3529H11.2941C10.7294 10.3529 10.3529 10.7294 10.3529 11.2941V12.2353C6.58824 12.2353 3.85882 9.31765 3.76471 5.64706H4.70588C5.27059 5.64706 5.64706 5.27059 5.64706 4.70588V0.941176C5.64706 0.376471 5.27059 0 4.70588 0H0.941176C0.376471 0 0 0.376471 0 0.941176V5.64706C0 11.3882 4.61176 16 10.3529 16H15.0588C15.6235 16 16 15.6235 16 15.0588V11.2941C16 10.7294 15.6235 10.3529 15.0588 10.3529Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconPhone',
};
</script>
